import { type Change, diffWords } from "diff";
import type { Version } from "./briefTypes";

export interface FieldDiff {
  label: string;
  oldValue: string | null;
  newValue: string | null;
}

export function stripHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent ?? "").replace(/\s+/g, " ").trim();
}

export function computeContentDiff(oldHtml: string, newHtml: string): Change[] {
  return diffWords(stripHtml(oldHtml), stripHtml(newHtml));
}

const FIELD_LABELS: { key: keyof Version; label: string }[] = [
  { key: "salaryBase", label: "Base Salary" },
  { key: "salaryBonus", label: "Bonus" },
  { key: "salaryEquity", label: "Equity" },
  { key: "salaryBenefits", label: "Benefits" },
  { key: "salaryCurrency", label: "Currency" },
  { key: "targetStartDate", label: "Target Start" },
];

export function computeFieldDiffs(oldVersion: Version, newVersion: Version): FieldDiff[] {
  const diffs: FieldDiff[] = [];
  for (const { key, label } of FIELD_LABELS) {
    const oldVal = oldVersion[key];
    const newVal = newVersion[key];
    if (String(oldVal ?? "") !== String(newVal ?? "")) {
      diffs.push({
        label,
        oldValue: oldVal != null ? String(oldVal) : null,
        newValue: newVal != null ? String(newVal) : null,
      });
    }
  }
  return diffs;
}
